export type NSType = 'COMMUNITY';
export const NS: NSType = 'COMMUNITY';
